export default __webpack_public_path__ + "static/media/Captura_de_Tela__25_-removebg-preview.bcc76d76.png";